/* The three content slots every view fills (app.ts renderers wrote into
   #banner, #sections, #footnote). In the React shell a view returns these
   three ids as siblings, so they stay DIRECT children of .wrap exactly as the
   static index.html laid them out — styles.css targets them by id. Use this
   helper (or replicate its markup) so every view's frame is identical.

   The shell renders #navigator and the persistent #live region itself; a view
   never renders those. */
import type { JSX, ReactNode } from "react";

export function ViewFrame({
  banner,
  children,
  footnote,
}: {
  /* the top banner strip — the view's title + one-line subtitle */
  banner?: ReactNode;
  /* the main content — what used to be #sections' innerHTML */
  children?: ReactNode;
  /* the footer note beneath the content */
  footnote?: ReactNode;
}): JSX.Element {
  return (
    <>
      <div id="banner">{banner}</div>
      <div id="sections">{children}</div>
      <div className="footer-note" id="footnote">
        {footnote}
      </div>
    </>
  );
}
